import { __assign } from '../_virtual/_tslib.js';
import 'react';
import 'styled-components';
import { fonts } from './fonts.js';
import { colors } from './colors.js';
export { brandColors, colors, scales } from './colors.js';
import { lightColorTokens as light$1, darkColorTokens as dark$1 } from './colorTokens.js';
var commons = {
  fonts: fonts,
  colors: colors
};
var light = Object.freeze(__assign(__assign({}, commons), {
  colorTokens: light$1
}));
var dark = Object.freeze(__assign(__assign({}, commons), {
  colorTokens: dark$1
}));
var themeList = {
  light: light,
  dark: dark
};
export { themeList };